import { create } from 'zustand';

export type PageTitleStatus = 'ready' | 'loading' | 'error';

export type PageTitleOverride = {
  status: PageTitleStatus;
  label?: string;
};

export type PageTitleState = PageTitleOverride & {
  locationKey: string;
};

type PageTitleStore = {
  state: PageTitleState | null;
  setPageTitleState: (locationKey: string, next: PageTitleOverride | null) => void;
};

/**
 * Title overrides scoped to React Router `location.key`.
 * Stale keys are ignored by DocumentTitleSync; clear is a no-op unless keys match.
 */
export const usePageTitleStore = create<PageTitleStore>((set, get) => ({
  state: null,
  setPageTitleState: (locationKey, next) => {
    if (next === null) {
      if (get().state?.locationKey === locationKey) {
        set({ state: null });
      }
      return;
    }
    set({
      state: {
        locationKey,
        status: next.status,
        label: next.label,
      },
    });
  },
}));
